const localeEn = {
  en: {
    CREHANA_FOR_BUSINESS: 'Crehana for businesses',

    SEO_DESCRIPTION:
      "We design agile training with professionals from Google, Facebook, Amazon, and more. Improve your team's skills in design, data, digital transformation, soft skills, and more.",

    HERO_BANNER_BUTTON: 'Start your free trial',

    TERMS_1: 'By requesting the demo I accept the',
    TERMS_2: 'terms and conditions',
    TERMS_3: 'of Crehana',

    FREE_TRIAL_BANNER_TITLE: 'Believing in your team is helping it grow',
    FREE_TRIAL_BANNER_DESCRIPTION:
      'Train your team interactively and closely in our digital learning ecosystem.',
    FREE_TRIAL_BANNER_BUTTON: 'Start your free trial',

    ABOUT_SECTION__FEATURE_TITLE_1: 'Our courses are available at any time.',
    ABOUT_SECTION__FEATURE_TITLE_2:
      "Access real-time statistics to see your team's progress.",
    ABOUT_SECTION__FEATURE_TITLE_3: 'Learn from industry expert mentors.',

    BANNER_SECTION_FORM_EMAIL: 'Email',
    BANNER_SECTION_FORM_EMAIL_ERROR: 'Enter a valid email',
    BANNER_SECTION_FORM_REQUIRED: 'Required field',
    BANNER_SECTION_FORM_MAX_LENGTH: 'Maximum 50 characters',
    BANNER_SECTION_FORM_BUTTON: 'Get started',
    BANNER_SECTION_BENEFITS_1: 'Diagnose your team',
    BANNER_SECTION_BENEFITS_2: 'Real-time analysis',
    BANNER_SECTION_BENEFITS_3: 'Develop your skills',
    BANNER_SECTION_WHATSAPP_BUTTON_1: 'Try it for Free',
    BANNER_SECTION_WHATSAPP_BUTTON_2: 'Contact Us',

    TRIAL_FORM_TITLE_1: 'for companies',
    TRIAL_FORM_TITLE_2: 'Experience it for 7 days',
    TRIAL_FORM_PROGRESS: 'Create your account: Step {{current}} of 3',
    TRIAL_FORM_FEATURE_TITLE: 'Experience it for 7 days',
    TRIAL_FORM_FEATURE_DESCRIPTION:
      'Complete your form to activate your free trial 🎉',
    TRIAL_FORM_FEATURE_ITEM_1: 'Diagnose your team',
    TRIAL_FORM_FEATURE_ITEM_2: 'Real-time analysis',
    TRIAL_FORM_FEATURE_ITEM_3: 'Develop your skills',
    TRIAL_FORM_FEATURE_ITEM_4: 'Create your own content',
    TRIAL_FORM_REQUIRED: 'Required field',
    TRIAL_FORM_MAX_LENGTH: 'Maximum 70 characters',
    TRIAL_FORM_ERROR_EMAIL: 'Enter a valid email',
    TRIAL_FORM_STEP_1_TITLE:
      'See how Crehana can help you develop skills and create your own content.',
    TRIAL_FORM_STEP_1_NAME: 'First Name',
    TRIAL_FORM_STEP_1_LASTNAME: 'Last Name',
    TRIAL_FORM_STEP_1_EMAIL: 'Corporate Email',
    TRIAL_FORM_STEP_1_BUTTON: 'Continue',
    TRIAL_FORM_STEP_2_TITLE:
      'Hundreds of companies like yours are using Crehana for businesses',
    TRIAL_FORM_STEP_2_COMPANY: 'Company Name',
    TRIAL_FORM_STEP_2_EMPLOYEES: 'Number of Employees',
    TRIAL_FORM_STEP_2_ROLE: 'Position or Job Title',
    TRIAL_FORM_STEP_2_BUTTON: 'Continue',
    TRIAL_FORM_STEP_3_TITLE:
      'Hundreds of companies like yours are using Crehana for businesses',
    TRIAL_FORM_STEP_3_PHONE: 'Phone Number',
    TRIAL_FORM_STEP_3_COUNTRY: 'Country',
    TRIAL_FORM_STEP_3_BUTTON: 'Finish',
    TRIAL_FORM_STEP_3_COUNTRY_1: 'Peru',
    TRIAL_FORM_STEP_3_COUNTRY_2: 'Argentina',
    TRIAL_FORM_STEP_3_COUNTRY_3: 'Mexico',
    TRIAL_FORM_STEP_3_COUNTRY_4: 'Colombia',
    TRIAL_FORM_STEP_3_COUNTRY_5: 'Spain',
    TRIAL_FORM_STEP_3_COUNTRY_6: 'Chile',
    TRIAL_FORM_STEP_3_COUNTRY_7: 'Others',
    TRIAL_FORM_STEP_4_TITLE:
      'Thank you very much for registering \n your data!',
    TRIAL_FORM_STEP_4_SUBTITLE:
      'We will be contacting you shortly \n to experience this.',

    TRIAL_FORM_COMPANY_TESTIMONIAL_TITLE: 'Teams that grow with us',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_1:
      '“It changed my way of seeing microlearning”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_1:
      "“Crehana's classes changed my perspective on microlearning, I would rather call it visually ergonomic knowledge fragmentation. You can easily listen to 50 minutes without feeling them.”",
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_1:
      'Regional Director of Human Talent at SURA Asset Management',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_2:
      '“The experience with Crehana was excellent”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_2:
      '“Our experience with Crehana was excellent. Not only because of the content of the platform, but also because of the contact and flexibility they gave us to use the licenses. I really liked the courses, the time for each part was perfect and I feel that the examples and explanations were very good. The platform is friendly, easy to use, and intuitive.”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_2:
      'Learning Coordinator at Entel Peru.',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_3:
      '“Crehana is an ally for our development”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_3:
      '“We are very grateful for the opportunity, our collaborators have received it with great enthusiasm and motivation since the topics are very good, current, and contribute a lot to the development of our people. From the HR point of view, Crehana is a strategic ally to build development and training plans, talent retention, and recognition and incentives.”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_3: 'HR Manager at Bioderma.',

    COMPANIES_SECTION_TITLE: 'Teams that grow with us',

    SOCIAL_VALIDATION_TITLE_1: 'Companies that \n trust us',
    SOCIAL_VALIDATION_TITLE_2: 'Employees \n learning',
    SOCIAL_VALIDATION_TITLE_3: 'Courses in our \n learning paths',

    BENEFITS_TITLE_1: 'Microsoft Teams Integration',
    BENEFITS_DESCRIPTION_1:
      'Have greater accessibility by accessing your courses from your Microsoft Teams account',
    BENEFITS_TITLE_2: 'Skill XP',
    BENEFITS_DESCRIPTION_2:
      'Identify your level of knowledge to enhance your learning and train in what you need.',
    BENEFITS_TITLE_3: 'Project-based methodology',
    BENEFITS_DESCRIPTION_3:
      'Continuous and flexible learning to immediately put your new skills into practice.',

    PERFORMANCE_BUTTON: 'Learn more',

    LEARN_SECTION_FEATURE_1_NAME: 'Classrooms',
    LEARN_SECTION_FEATURE_1_DESCRIPTION:
      "Upload your own content and create groups to decide who can see your organization's courses.",
    LEARN_SECTION_FEATURE_1_BUTOON: 'Learn more',
    LEARN_SECTION_FEATURE_2_NAME: 'Develop',
    LEARN_SECTION_FEATURE_2_DESCRIPTION:
      'Whether acquiring new skills or developing existing ones, this is where your team members learn.',
    LEARN_SECTION_FEATURE_2_BUTOON: 'Learn more',

    SKILL_IQ_SECTION_TITLE: 'Skill XP',
    SKILL_IQ_SECTION_BUTTON: 'Learn more',

    TRACK_SECTION_TITLE: 'OUR LEARNING PATH',
    TRACK_SECTION_SUBTITLE_1: 'Learn',
    TRACK_SECTION_SUBTITLE_2: 'from recognized specialists worldwide',
    TRACK_SECTION_BUTTON: 'See all routes',
    TRACK_SECTION_TRACK_1_NAME: 'Sales',
    TRACK_SECTION_TRACK_1_DESCRIPTION:
      'Efficiently and strategically manage your clients for better results. Give your clients exactly what they are looking for and build lasting relationships.',
    TRACK_SECTION_TRACK_1_BUTTON: 'View Route Detail',
    TRACK_SECTION_TRACK_1_OCCUPATION: 'Account Manager at Google',
    TRACK_SECTION_TRACK_1_TITLE: 'Software you will learn',
    TRACK_SECTION_TRACK_2_NAME: 'Leadership',
    TRACK_SECTION_TRACK_2_DESCRIPTION:
      'Know the skills that a good leader must develop to create a culture of trust and drive growth in their team.',
    TRACK_SECTION_TRACK_2_BUTTON: 'View Route Detail',
    TRACK_SECTION_TRACK_2_OCCUPATION: 'Life and Executive Coach',
    TRACK_SECTION_TRACK_2_TITLE: '',
    TRACK_SECTION_TRACK_3_NAME: 'Innovation',
    TRACK_SECTION_TRACK_3_DESCRIPTION:
      'Learn to implement an innovation project in your work, based on service design and Design Thinking to understand your user.',
    TRACK_SECTION_TRACK_3_BUTTON: 'View Route Detail',
    TRACK_SECTION_TRACK_3_OCCUPATION: 'Service Design & UX at Citibank',
    TRACK_SECTION_TRACK_3_TITLE: '',
    TRACK_SECTION_TRACK_4_NAME: 'E-commerce',
    TRACK_SECTION_TRACK_4_DESCRIPTION:
      'Create your own online sales strategies, set up your online store, and create a new channel to transform your business.',
    TRACK_SECTION_TRACK_4_BUTTON: 'View Route Detail',
    TRACK_SECTION_TRACK_4_OCCUPATION: 'Sr Product Manager at Amazon',
    TRACK_SECTION_TRACK_4_TITLE: 'Software you will learn',

    TESTIMONIAL_SECTION_1_TITLE: '“The experience with Crehana was excellent”',
    TESTIMONIAL_SECTION_1_CONTENT:
      'Our experience with Crehana was excellent. Not only because of the content of the platform, but also because of the contact and flexibility they gave us to use the licenses. I really liked the courses, the time for each part was perfect and I feel that the examples and explanations were very good. The platform is friendly, easy to use, and intuitive.',
    TESTIMONIAL_SECTION_1_OCCUPATION: 'Learning Coordinator at Entel Peru.',
    TESTIMONIAL_SECTION_2_TITLE: '“It changed my way of seeing microlearning”',
    TESTIMONIAL_SECTION_2_CONTENT:
      "Crehana's classes changed my perspective on microlearning, I would rather call it visually ergonomic knowledge fragmentation. You can easily listen to 50 minutes without feeling them.",
    TESTIMONIAL_SECTION_2_OCCUPATION:
      'Regional Director of Human Talent at SURA Asset Management',
    TESTIMONIAL_SECTION_3_TITLE: '“Crehana is an ally for our development”',
    TESTIMONIAL_SECTION_3_CONTENT:
      'We are very grateful for the opportunity, our collaborators have received it with great enthusiasm and motivation since the topics are very good, current, and contribute a lot to the development of our people. From the HR point of view, Crehana is a strategic ally to build development and training plans, talent retention, and recognition and incentives.',
    TESTIMONIAL_SECTION_3_OCCUPATION: 'HR Manager at Bioderma.',

    BLOG_SECTION_TITLE_1: 'Content',
    BLOG_SECTION_TITLE_2: 'that accompanies your growth',
    BLOG_SECTION_BUTTON: 'Go to Blog',

    VIDEO_SECTION_TITLE_HIGHLIGHT: 'Learning together,',
    VIDEO_SECTION_TITLE: 'we all grow',
    VIDEO_SECTION_DESCRIPTION:
      'Crehana for businesses is a strategic partner that helps your organization overcome learning and communication challenges through education.',
    VIDEO_SECTION_BUTTON: 'Try it for Free',

    DOWNLOADABLE_CARD_DETAIL: 'View detail',
    DOWNLOADABLE_DOWNLOADS: 'downloads',

    SOCIAL_NOTIFICATION_TITLE: 'They have joined Crehana!',
  },
};

export default localeEn;
